import superMeta from '../_DES_CAT/metaDesCatNode.mjs'

export default {
    ...superMeta,
    name: '软件需求',
    type: 'DES_DES',
}
